import React, { FC } from 'react';

import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import * as keyset from 'i18n/AliceExternalAppForm';

import styles from './AliceExternalAppEditPage.module.scss';

const t = i18n(keyset);

interface Props {
    status: 'pending' | 'processed' | 'failed' | string;
    error?: string;
}

const STATUS_LABEL_KEYS: Record<string, keyof typeof keyset.en> = {
    pending: 'resource-status-pending',
    processed: 'resource-status-processed',
    failed: 'resource-status-failed',
};

const STATUS_VARIANT_CLASS: Record<string, string> = {
    pending: styles.statusBadge_pending,
    processed: styles.statusBadge_processed,
    failed: styles.statusBadge_failed,
};

export const ProcessingStatusBadge: FC<Props> = ({ status, error }) => {
    const labelKey = STATUS_LABEL_KEYS[status] ?? 'resource-status-pending';
    const variantClass = STATUS_VARIANT_CLASS[status] ?? styles.statusBadge_pending;
    return (
        <div className={clx(styles.statusBadge, variantClass)}>
            {t(labelKey)}
            {status === 'failed' && error ? `: ${error}` : null}
        </div>
    );
};
